module.exports = __webpack_public_path__ + "img/deleteIcon.e2c091c.svg";